<app-lfsa-card [innTemplate]="enviarTemplate" [titulo]="tituloCard" *ngIf="!mostrarFormulario" [optionsExport]="false">
</app-lfsa-card>

<ng-template #enviarTemplate>
  <h2 class="container float-left">{{ tituloForm }}</h2>
  <div class="row form-group">
    <div class="form-group col-md-2" style="display: flex;justify-content: start;align-items: center;">
      <input class="form-control" placeholder="Buscar.. " [(ngModel)]="textoBuscar " id="quickFilter "
        (keyup)="onQuickFilterChanged() " #quickFilter />
    </div>
    <div class="form-group col-12 col-md-2">
      <div [formGroup]="formularioFiltroTipoDeVendedores" novalidate class="form-group">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'descripcion'" [idOpcion]="'idTipo'"
          [comboBox]="listTiposDeVendedoresFiltro" [label]="'Tipo de Vendedor *'" formControlName="idTipoVendedor"
          [control]="formularioFiltroTipoDeVendedores.get('idTipoVendedor')" [id]="'idTipoVendedor'">
        </app-lfsa-combo-box>
      </div>
    </div>
    <div class="form-group col-md-2" style="display: flex;justify-content: start;align-items: center;">
      <button (click)="eliminarTodosLosRegistros()" class={{DAT_BTNCSS.danger}}>
        Eliminar
      </button>
    </div>
    <div class="form-group col-md-2" style="display: flex;justify-content: start;align-items: center;">
      <button (click)="descargarExcel()" class={{DAT_BTNCSS.success}}>Descargar</button>
    </div>
    <div class="form-group col-md-2" style="display: flex;justify-content: start;align-items: center;">
      <button (click)="nuevo()" class={{DAT_BTNCSS.success}}>{{DAT_BTNS.agregar}}</button>
    </div>
    <div class="form-group col-md-2" style="display: flex;justify-content: start;align-items: center;">
      <a href="comisiones/cumplimiento-vs-ganancia-csv" style="width: 100%;">
        <button class={{DAT_BTNCSS.success}}>Cargar</button>
      </a>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-md-12">
      <ag-grid-angular class="{{modulo.agGrid.class}}" #agGrid [ngStyle]="modulo.agGrid.style" id="{{modulo.agGrid.id}}"
        [paginationPageSize]="modulo.agGrid.paginacion" [pagination]="true" [frameworkComponents]="frameworkComponents"
        [columnDefs]="columnDefs" [rowSelection]="rowSelection" [rowData]="rowData" (gridReady)="onGridReady($event)">
      </ag-grid-angular>
    </div>
  </div>
</ng-template>

<app-lfsa-card [innTemplate]="enviarTemplateResport" [titulo]="tituloForm" *ngIf="mostrarFormulario">
</app-lfsa-card>
<ng-template #enviarTemplateResport>
  <div [formGroup]="formulario" novalidate class="form-group">
    <div class="row">
      <div class="form-group col-12 col-md-9">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'descripcion'" [idOpcion]="'idTipo'"
          [comboBox]="listTiposDeVendedores" formControlName="tipoVendedorId"
          [control]="formulario.get('tipoVendedorId')" [label]="'Seleccione Estructura *'" [id]="'tipoVendedorId'">
        </app-lfsa-combo-box>
      </div>
      <div class="form-group col-12 col-md-3">
        <app-lfsa-input [isReadOnly]="true" [type]="'number'" [class]="'letrasDanger'"
          [placeholder]="'Ingrese Sueldo Base'" [label]="'Sueldo Base *'" [id]="'sueldoVariable'"
          formControlName="sueldoVariable" [control]="formulario.get('sueldoVariable')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-12">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'descripcion'" [idOpcion]="'idVariable'"
          [comboBox]="listTiposDeVariables" formControlName="variableId" [control]="formulario.get('variableId')"
          [label]="'Seleccione Variable *'" [id]="'variableId'">
        </app-lfsa-combo-box>
      </div>
      <div class="form-group col-12 col-md-4">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'valor'" [idOpcion]="'clave'"
          [comboBox]="cmbTipoAsignacion" formControlName="tipoAsignacionCumplGanan"
          [control]="formulario.get('tipoAsignacionCumplGanan')" [label]="'Seleccione Tipo de Asignación *'"
          [id]="'tipoAsignacionCumplGanan'">
        </app-lfsa-combo-box>
      </div>
      <div class="form-group col-12 col-md-4">
        <app-lfsa-input [type]="'number'" [class]="'letrasDanger'" [placeholder]="'Ingrese % de Cumplimiento'"
          [label]="(formulario.get('tipoAsignacionCumplGanan').value == 'ASIGNACION_RANGO') ? '% de Cumplimiento Inicial *' : '% de Cumplimiento *'"
          [id]="'cumplimiento'" formControlName="cumplimiento"
          [control]="formulario.get('cumplimiento')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-4"
        *ngIf="formulario.get('tipoAsignacionCumplGanan').value == 'ASIGNACION_RANGO'">
        <app-lfsa-input [type]="'number'" [class]="'letrasDanger'" [placeholder]="'Ingrese % de Cumplimiento Final'"
          [label]="'% de Cumplimiento Final *'" [id]="'cumplimientoFinal'" formControlName="cumplimientoFinal"
          [control]="formulario.get('cumplimientoFinal')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-4">
        <app-lfsa-input [type]="'number'" [class]="'letrasDanger'" [placeholder]="'Ingrese % de Ganancia'"
          [label]="'% de Ganancia *'" [id]="'ganancia'" formControlName="ganancia"
          [control]="formulario.get('ganancia')"></app-lfsa-input>
      </div>
    </div>
    <app-lfsa-botones-formulario [formularioValido]="formulario.invalid" (devolverAccion)="acciones( $event )"
      [textBoton]="textBoton"></app-lfsa-botones-formulario>
  </div>

</ng-template>

<app-lfsa-modal [innTemplate]="enviarModal" [titulo]="'Editar Cumplimiento vs Ganancia por Tipo de Vendedor y Ganancia'"
  [idButton]="'buttonAbrirModal'" [idOpen]="'abrirModal'" [idClose]="'cerrarModal'"></app-lfsa-modal>
<ng-template #enviarModal>
  <div [formGroup]="formulario" novalidate class="form-group">
    <div class="row">
      <div class="form-group col-12 col-md-12">
        <app-lfsa-input [isReadOnly]="true" [type]="'number'" [class]="'letrasDanger'" [placeholder]="'Ingrese ID'"
          [label]="'ID *'" [id]="'idCumpleGana'" formControlName="idCumpleGana"
          [control]="formulario.get('idCumpleGana')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-9">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'descripcion'" [idOpcion]="'idTipo'"
          [comboBox]="listTiposDeVendedores" formControlName="tipoVendedorId"
          [control]="formulario.get('tipoVendedorId')" [label]="'Seleccione Estructura *'" [id]="'tipoVendedorId'">
        </app-lfsa-combo-box>
      </div>
      <div class="form-group col-12 col-md-3">
        <app-lfsa-input [isReadOnly]="true" [type]="'number'" [class]="'letrasDanger'"
          [placeholder]="'Ingrese Sueldo Base'" [label]="'Sueldo Base *'" [id]="'sueldoVariable'"
          formControlName="sueldoVariable" [control]="formulario.get('sueldoVariable')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-12">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'descripcion'" [idOpcion]="'idVariable'"
          [comboBox]="listTiposDeVariables" formControlName="variableId" [control]="formulario.get('variableId')"
          [label]="'Seleccione Variable *'" [id]="'variableId'">
        </app-lfsa-combo-box>
      </div>
      <div class="form-group col-12 col-md-4">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'valor'" [idOpcion]="'clave'"
          [comboBox]="cmbTipoAsignacion" formControlName="tipoAsignacionCumplGanan"
          [control]="formulario.get('tipoAsignacionCumplGanan')" [label]="'Seleccione Tipo de Asignación *'"
          [id]="'tipoAsignacionCumplGanan'">
        </app-lfsa-combo-box>
      </div>
      <div class="form-group col-12 col-md-4">
        <app-lfsa-input [type]="'number'" [class]="'letrasDanger'" [placeholder]="'Ingrese % de Cumplimiento'"
          [label]="(formulario.get('tipoAsignacionCumplGanan').value == 'ASIGNACION_RANGO') ? '% de Cumplimiento Inicial *' : '% de Cumplimiento *'"
          [id]="'cumplimiento'" formControlName="cumplimiento"
          [control]="formulario.get('cumplimiento')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-4"
        *ngIf="formulario.get('tipoAsignacionCumplGanan').value == 'ASIGNACION_RANGO'">
        <app-lfsa-input [type]="'number'" [class]="'letrasDanger'" [placeholder]="'Ingrese % de Cumplimiento Final'"
          [label]="'% de Cumplimiento Final *'" [id]="'cumplimientoFinal'" formControlName="cumplimientoFinal"
          [control]="formulario.get('cumplimientoFinal')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-4">
        <app-lfsa-input [type]="'number'" [class]="'letrasDanger'" [placeholder]="'Ingrese % de Ganancia'"
          [label]="'% de Ganancia *'" [id]="'ganancia'" formControlName="ganancia"
          [control]="formulario.get('ganancia')"></app-lfsa-input>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="form-group col-12 col-md-4"></div>
    <div class="form-group col-12 col-md-4">
      <button class="btn btn-success btn-block" [disabled]="formulario.invalid" (click)="actualizar()">
        <i class="fa fa-save"></i>
        Guardar</button>
    </div>
    <div class="form-group col-12 col-md-4"></div>
  </div>
</ng-template>